/* SkyClean Drones – Bewegung der Designebene „X".

   Drei Dinge, die sich mit CSS allein nicht lösen lassen:

     1 · Glasleiste      – die Kopfleiste erfährt, dass gescrollt wurde
     2 · Einblenden      – Abschnitte kommen beim Scrollen einmal herein
     3 · Reinigungslupe  – der Zeiger putzt einen Kreis im Kopfbild frei

   Bewusst nicht hier: hochzählende Zahlen. Die Kennwerte auf dieser Seite
   sind Aussagen („40 m Arbeitshöhe"), keine Vorführung. Eine Zahl, die
   erst durch andere Zahlen läuft, lenkt davon ab und wirkt wie Werbung.

   Grundsatz: Ohne dieses Skript ist die Seite vollständig sichtbar und
   bedienbar. Die Klasse .x-js auf <html> wird hier gesetzt; das CSS blendet
   erst dann etwas aus, wenn das Einblenden auch stattfinden kann. */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var hasIO = 'IntersectionObserver' in window;

  if (hasIO && !reduce) root.classList.add('x-js');

  /* ---------------------------------------------------------- 1 · Glasleiste */
  var scrolled = false;
  function onScroll() {
    var past = window.scrollY > 12;
    if (past === scrolled) return;
    scrolled = past;
    root.classList.toggle('x-scrolled', past);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* --------------------------------------------------------- 2 · Einblenden */
  function reveal(scope) {
    var nodes = scope.querySelectorAll('.x-reveal:not(.is-in)');
    if (!nodes.length) return;

    if (!hasIO || reduce) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    nodes.forEach(function (n, i) {
      if (!n.style.getPropertyValue('--d')) {
        var pos = n.parentElement ? Array.prototype.indexOf.call(n.parentElement.children, n) : i;
        n.style.setProperty('--d', Math.min(pos, 6) * 80 + 'ms');
      }
      io.observe(n);
    });

    /* Sicherheitsnetz: Was nach 2,5 s noch wartet, wird sichtbar gemacht.
       Lieber ohne Animation zu sehen als gar nicht. */
    setTimeout(function () {
      document.querySelectorAll('.x-reveal:not(.is-in)').forEach(function (n) { n.classList.add('is-in'); });
    }, 2500);
  }

  /* ----------------------------------------------------- 3 · Reinigungslupe
     Über dem großen Kopfbild wird alles außerhalb eines weichen Kreises matt
     und grau; unter dem Zeiger bleibt es klar. Das ist genau das, was die
     Firma verkauft – deshalb bleibt dieser eine Effekt.

     Der Kreis folgt gedämpft (16 % je Bild), damit die Bewegung weich wirkt.
     Die Schleife läuft nur, solange der Zeiger über dem Bild liegt. */
  function lens(tile) {
    if (tile.dataset.xLens) return;
    tile.dataset.xLens = '1';

    var target = { x: 0, y: 0 };
    var eased = { x: 0, y: 0 };
    var running = false;
    var first = true;

    function frame() {
      if (!running) return;
      eased.x += (target.x - eased.x) * 0.16;
      eased.y += (target.y - eased.y) * 0.16;
      tile.style.setProperty('--mx', eased.x.toFixed(1) + 'px');
      tile.style.setProperty('--my', eased.y.toFixed(1) + 'px');
      requestAnimationFrame(frame);
    }
    function at(ev) {
      var r = tile.getBoundingClientRect();
      target.x = ev.clientX - r.left;
      target.y = ev.clientY - r.top;
    }

    tile.addEventListener('pointerenter', function (ev) {
      if (ev.pointerType !== 'mouse') return;
      at(ev);
      if (first) { eased.x = target.x; eased.y = target.y; first = false; }
      tile.classList.add('is-lens');
      if (!running) { running = true; requestAnimationFrame(frame); }
    });
    tile.addEventListener('pointermove', function (ev) {
      if (ev.pointerType !== 'mouse') return;
      at(ev);
    }, { passive: true });
    tile.addEventListener('pointerleave', function () {
      tile.classList.remove('is-lens');
      running = false;
    });
  }

  /* -------------------------------------------------------------- Aufbau */
  function init(scope) {
    scope = scope || document;
    reveal(scope);
    if (fine && !reduce) scope.querySelectorAll('.scx-mosaic-main').forEach(lens);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
